import React, { useState, useRef } from "react";
import { leftArrow, playBtnIcon, rightArrow } from "../../../constants/icons";
import Slider from "react-slick";

const PostVideoComponent = ({ className, postVideosData }) => {
  const [showSlider, setShowSlider] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const sliderRef = useRef(null);
  const videoRefs = useRef([]);

  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  const handleShowAllVideos = (index = 0) => {
    setActiveIndex(index);
    setShowSlider(true);
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: activeIndex,
    adaptiveHeight: true,
    afterChange: (current) => {
      setIsAtStart(current === 0);
      setIsAtEnd(current === postVideosData.length - 1);
    },
  };

  const handlePrevSlide = (e) => {
    e.preventDefault();
    // Pause the current video before sliding
    if (videoRefs.current[sliderRef.current.innerSlider.state.currentSlide]) {
      videoRefs.current[
        sliderRef.current.innerSlider.state.currentSlide
      ].pause();
    }
    sliderRef.current.slickPrev();
  };

  const handleNextSlide = (e) => {
    e.preventDefault();
    // Pause the current video before sliding
    if (videoRefs.current[sliderRef.current.innerSlider.state.currentSlide]) {
      videoRefs.current[
        sliderRef.current.innerSlider.state.currentSlide
      ].pause();
    }
    sliderRef.current.slickNext();
  };

  return (
    <>
      {postVideosData && postVideosData.length > 0 && (
        <>
          {!showSlider && (
            <div className={`${className || ''} post-img-wrapper border-radius-3 mb-2 ${postVideosData.length === 1 ? 'myk__stu-post-1' : ''} ${postVideosData.length === 2 ? 'myk__stu-post-2' : ''}`}>
              {postVideosData.slice(0, 3).map((video, index) => (
                <div key={index} className="myk__stu-comm-thumbnail-wrapper">
                  <img
                    src={video.postVideoThumbnail}
                    className="img-fluid w-100"
                    alt={`Video Thumbnail ${index + 1}`}
                  />
                  <span onClick={() => handleShowAllVideos(index)} className="myk__stu-comm-play-btn">{playBtnIcon}</span>
                </div>
              ))}
              {postVideosData.length > 3 && (
                <div
                  className="myk__stu-show-all-imgs"
                  onClick={() => handleShowAllVideos(2)}
                >
                  <span>
                    + <strong>{postVideosData.length - 2}</strong>
                  </span>
                </div>
              )}
            </div>
          )}

          {showSlider && (
            <div className={`${className || ''} slider-comm_images-wrapper slider-comm_videos-wrapper`}>
              <div className="myk_stu-carousel-action">
                <button
                  className={`btn-move btn-prev  border-0 ${isAtStart ? 'disabled' : ''}`} 
                  onClick={handlePrevSlide}
                >
                  {leftArrow} {/* Replace with your left arrow icon */}
                </button>
                <button
                  className={`btn-move btn-btn-next border-0 ${isAtEnd ? 'disabled' : ''}`} 
                  onClick={handleNextSlide}
                >
                  {rightArrow} {/* Replace with your right arrow icon */}
                </button>
              </div>
              <Slider {...settings} ref={sliderRef}>
                {postVideosData.map((video, index) => (
                  <div key={index} className="item">
                    <h4>{video.postVideoTitle}</h4>
                    <video
                      width="100%"
                      height="240"
                      controls
                      ref={(el) => (videoRefs.current[index] = el)} // Store video reference
                    >
                      <source src={video.postVideo} type="video/mp4" />
                      <source src={video.postVideo} type="video/ogg" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ))}
              </Slider>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default PostVideoComponent;